import {
  FETCH_PARKING_PERMIT_TYPES,
  FETCH_PARKING_PERMIT_TYPES_SUCCESS,
  FETCH_PARKING_PERMIT_TYPES_FAILURE,
  CREATE_PARKING_PERMIT_TYPE,
  CREATE_PARKING_PERMIT_TYPE_SUCCESS,
  CREATE_PARKING_PERMIT_TYPE_FAILURE,
  UPDATE_PARKING_PERMIT_TYPE,
  UPDATE_PARKING_PERMIT_TYPE_SUCCESS,
  UPDATE_PARKING_PERMIT_TYPE_FAILURE,
  DEACTIVATE_PARKING_PERMIT_TYPE,
  DEACTIVATE_PARKING_PERMIT_TYPE_SUCCESS,
  DEACTIVATE_PARKING_PERMIT_TYPE_FAILURE,
  FETCH_PERMIT_TYPE_TRANS_DOCS,
  FETCH_PERMIT_TYPE_TRANS_DOCS_SUCCESS,
  FETCH_PERMIT_TYPE_TRANS_DOCS_FAILURE,
  FETCH_AUTO_ASSIGN_CONFIG,
  FETCH_AUTO_ASSIGN_CONFIG_SUCCESS,
  FETCH_AUTO_ASSIGN_CONFIG_FAILURE,
  UPDATE_AUTO_ASSIGN_CONFIG,
  UPDATE_AUTO_ASSIGN_CONFIG_SUCCESS,
  UPDATE_AUTO_ASSIGN_CONFIG_FAILURE,
} from './types';

const initialState = {
  permitTypes: [],
  transDocs: [],
  selectedAutoAssignConfig: null,
  autoAssignConfigLoading: false,
  loading: false,
  error: null,
};

const parkingPermitTypesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    // Fetch all permit types
    case FETCH_PARKING_PERMIT_TYPES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PARKING_PERMIT_TYPES_SUCCESS:
      return {
        ...state,
        permitTypes: payload,
        loading: false,
      };
    case FETCH_PARKING_PERMIT_TYPES_FAILURE:
      return {
        ...state,
        loading: false,
        error: 'Failed to fetch parking permit types',
      };

    // Create permit type
    case CREATE_PARKING_PERMIT_TYPE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_PARKING_PERMIT_TYPE_SUCCESS:
      return {
        ...state,
        permitTypes: [...state.permitTypes, payload],
        loading: false,
      };
    case CREATE_PARKING_PERMIT_TYPE_FAILURE:
      return {
        ...state,
        loading: false,
        error: 'Failed to create parking permit type',
      };

    // Update permit type
    case UPDATE_PARKING_PERMIT_TYPE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_PARKING_PERMIT_TYPE_SUCCESS:
      return {
        ...state,
        permitTypes: state.permitTypes.map((pt) =>
          pt.parkingPermitTypeId === payload.parkingPermitTypeId ? payload : pt
        ),
        loading: false,
      };
    case UPDATE_PARKING_PERMIT_TYPE_FAILURE:
      return {
        ...state,
        loading: false,
        error: 'Failed to update parking permit type',
      };

    // Deactivate permit type
    case DEACTIVATE_PARKING_PERMIT_TYPE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DEACTIVATE_PARKING_PERMIT_TYPE_SUCCESS:
      return {
        ...state,
        permitTypes: state.permitTypes.map((pt) =>
          pt.parkingPermitTypeId === payload ? { ...pt, isActive: false } : pt
        ),
        loading: false,
      };
    case DEACTIVATE_PARKING_PERMIT_TYPE_FAILURE:
      return {
        ...state,
        loading: false,
        error: 'Failed to deactivate parking permit type',
      };

    // Fetch trans docs
    case FETCH_PERMIT_TYPE_TRANS_DOCS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PERMIT_TYPE_TRANS_DOCS_SUCCESS:
      return {
        ...state,
        transDocs: payload,
        loading: false,
      };
    case FETCH_PERMIT_TYPE_TRANS_DOCS_FAILURE:
      return {
        ...state,
        loading: false,
        error: 'Failed to fetch transaction documents',
      };

    // Fetch auto-assign config
    case FETCH_AUTO_ASSIGN_CONFIG:
      return {
        ...state,
        autoAssignConfigLoading: true,
        error: null,
      };
    case FETCH_AUTO_ASSIGN_CONFIG_SUCCESS:
      return {
        ...state,
        selectedAutoAssignConfig: payload,
        autoAssignConfigLoading: false,
      };
    case FETCH_AUTO_ASSIGN_CONFIG_FAILURE:
      return {
        ...state,
        autoAssignConfigLoading: false,
        error: 'Failed to fetch auto-assign configuration',
      };

    // Update auto-assign config
    case UPDATE_AUTO_ASSIGN_CONFIG:
      return {
        ...state,
        autoAssignConfigLoading: true,
        error: null,
      };
    case UPDATE_AUTO_ASSIGN_CONFIG_SUCCESS:
      return {
        ...state,
        selectedAutoAssignConfig: payload,
        autoAssignConfigLoading: false,
      };
    case UPDATE_AUTO_ASSIGN_CONFIG_FAILURE:
      return {
        ...state,
        autoAssignConfigLoading: false,
        error: 'Failed to update auto-assign configuration',
      };

    default:
      return state;
  }
};

export default parkingPermitTypesReducer;
